import { Dispatch, memo, SetStateAction, useMemo } from 'react'
import CheckboxInput from '../../../components/inputs/CheckboxInput'
import { USER_ROLES_IDS } from '../../../constants/common'
import useAuthStore from '../../../store/Auth'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { APP_ROUTES } from '../../../routes'

interface AcknowledgementProps {
    isQualifiedPersonnelOnly: boolean
    setIsQualifiedPersonnelOnly: Dispatch<SetStateAction<boolean>>
    isSafetyBriefingConducted: boolean
    setIsSafetyBriefingConducted: Dispatch<SetStateAction<boolean>>
    isAgreeStopWorkIfConditionsChange: boolean
    setIsAgreeStopWorkIfConditionsChange: Dispatch<SetStateAction<boolean>>
    isFieldsDisabled: boolean
}

const Acknowledgement = ({
    isQualifiedPersonnelOnly,
    setIsQualifiedPersonnelOnly,
    isSafetyBriefingConducted,
    setIsSafetyBriefingConducted,
    isAgreeStopWorkIfConditionsChange,
    setIsAgreeStopWorkIfConditionsChange,
    isFieldsDisabled
}: AcknowledgementProps) => {
    const { user } = useAuthStore()

    const { t } = useTranslation()

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const key = searchParams.get("ID");

    const isApprovePermitPage = useMemo(
        () => location.pathname === APP_ROUTES.APPROVE_PERMIT_TO_WORK,
        [location.pathname],
    );

    return (
        <>
            {user?.n_RoleID === USER_ROLES_IDS.STAFF &&
                (key && isApprovePermitPage ? (
                    <></>
                ) : (
                    <div className="flex flex-col gap-3 bg-white p-4 rounded-xl shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]">
                        <CheckboxInput
                            id="qualifiedPersonnelOnly"
                            label={t("qualifiedPersonnelOnly")}
                            labelStyles="leading-[1.2]"
                            checked={
                                isQualifiedPersonnelOnly ||
                                (user?.n_RoleID === USER_ROLES_IDS.STAFF &&
                                    isFieldsDisabled)
                            }
                            setChecked={setIsQualifiedPersonnelOnly}
                            readOnly={
                                user?.n_RoleID === USER_ROLES_IDS.STAFF &&
                                isFieldsDisabled
                            }
                        />
                        <CheckboxInput
                            id="safetyBriefingConducted"
                            label={t("safetyBriefingConducted")}
                            labelStyles="leading-[1.2]"
                            checked={
                                isSafetyBriefingConducted ||
                                (user?.n_RoleID === USER_ROLES_IDS.STAFF &&
                                    isFieldsDisabled)
                            }
                            setChecked={setIsSafetyBriefingConducted}
                            readOnly={
                                user?.n_RoleID === USER_ROLES_IDS.STAFF &&
                                isFieldsDisabled
                            }
                        />
                        <CheckboxInput
                            id="agreeStopWorkIfConditionsChange"
                            label={t("agreeStopWorkIfConditionsChange")}
                            labelStyles="leading-[1.2]"
                            checked={
                                isAgreeStopWorkIfConditionsChange ||
                                (user?.n_RoleID === USER_ROLES_IDS.STAFF &&
                                    isFieldsDisabled)
                            }
                            setChecked={setIsAgreeStopWorkIfConditionsChange}
                            readOnly={
                                user?.n_RoleID === USER_ROLES_IDS.STAFF &&
                                isFieldsDisabled
                            }
                        />
                    </div>
                ))}
        </>
    )
}

export default memo(Acknowledgement)
